import { isDefinedString } from "et3-type-guards";
import getTBWStore from "../../../../stores/developer-store/tbw-store";
import { withLiteObserverAndTheme } from "../../../et3-enhanced-render";
import NumberOfTemporaryBanDays from "./number-of-temporary-ban-days";
import TBWPopUpButtons from "./tbw-pop-up-buttons";
import ET3Div from "../../../et3-div";
import Et3Margin from "../../../et3-ui/ET3Margin";
import Et3Picker from "../../../et3-input/et3-picker";
import { TEt3PickerMultipleValue } from "../../../../TypesNEW";

const TBWPopUp = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const data = getTBWStore()
    .TBWreasons.get()
    .map((reason) => {
      return { label: reason.tbwName, value: reason.id.toString() };
    })
    .filter((data) => {
      return isDefinedString(data.label);
    });

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      fDirection="column"
      justifyContent="space-around"
      alignItems="center"
      withShadow={false}
      width={1000}
      height={250}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <Et3Margin top={20} bottom={0} left={0} right={0} />
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={300}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Picker
          label=""
          style={{}}
          options={data}
          value={getTBWStore().getTWBReasonSelectValue()}
          onChoose={(value: TEt3PickerMultipleValue) => {
            getTBWStore().setTBWReasons(value);
          }}
          onClick={() => {}}
          isMultiple={true}
          onEnter={() => {}}
          containerStyle={{}}
        />
      </ET3Div>
      <Et3Margin top={20} bottom={0} left={0} right={0} />
      <NumberOfTemporaryBanDays />
      <TBWPopUpButtons />
    </ET3Div>
  );
});

export default TBWPopUp;
